<template>
  <div class="dollhouse-card dev-wish-card" v-motion-slide-visible-bottom>
    <div class="dev-tag">DEV   </div>
    <div class="flex justify-between items-start mb-4">
      <div>
        <h3 class="text-lg font-semibold text-nirvana-blue">
          Handlers ทีมพัฒนา - Kanosume 'Kurumina' Umiki
        </h3>
        <a 
          v-if="wish.twitter"
          :href="`https://twitter.com/${wish.twitter}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text-sm text-nirvana-light-blue hover:text-nirvana-blue transition-colors"
        >
          @{{ wish.twitter }}
        </a>
      </div>
    </div>

    <p class="text-gray-700 mb-4 whitespace-pre-wrap">{{ wish.message }}</p>

    <img
      v-if="wish.fanart"
      :src="wish.fanart"
      :alt="`แฟนอาร์ตโดยทีมพัฒนา`"
      class="w-full max-h-60 object-contain rounded-lg mb-4 shadow-dollhouse"
      loading="lazy"
    />

    <!-- Date and social buttons -->
    <div class="flex justify-between items-center mt-4">
      <span class="text-sm text-gray-500">
        {{ formatDate(wish.createdAt) }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { Twitter, Facebook, Link, ArrowUpRightSquare } from 'lucide-vue-next'
import { format } from 'date-fns'

const props = defineProps({
  wish: {
    type: Object,
    required: true
  }
})

const socials = [
  { type: 'twitter', name: 'Twitter', icon: Twitter },
  { type: 'facebook', name: 'Facebook', icon: Facebook },
  { type: 'copy', name: 'Copy Link', icon: Link }
]

function formatDate(date) {
  return format(new Date(date), 'MMM d, yyyy')
}

function shareWish(type) {
  const text = `มาอวยพรวันเกิดให้น้องเนอร์กัน~! #HBDNirvana2025 #NirvanaARP #UtopiaARP #ARProject`
  const url = `${window.location.origin}/wish/${props.wish.number}`

  switch (type) {
    case 'twitter':
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`)
      break
    case 'facebook':
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)
      break
    case 'copy':
      navigator.clipboard.writeText(url)
      break
  }
}

function openWish() {
  window.open(`${window.location.origin}/wish/${props.wish.number}`, '_blank')
}
</script>

<style scoped>
.dev-wish-card {
  background: linear-gradient(145deg, #ffffff, #fdf7e4);
  border: 2px solid #ffd700;
  position: relative;
  overflow: hidden;
}

.dev-tag {
  position: absolute;
  top: 15px;
  right: -35px;
  background: #ffd700;
  color: #333;
  font-weight: bold;
  padding: 6px 0; /* Adjust padding */
  transform: rotate(45deg);
  font-size: 0.75rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
  width: 100px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px; /* Ensures vertical centering */
}
</style>
